<template>
    <div>
        <el-table
            class="adv-table"
            style="width: 100%"
            :data="advList"
            header-row-class-name="content-header-row"
            header-cell-class-name="content-header-cell"
            cell-class-name="content-cell"
        >
            <el-table-column width="40"> </el-table-column>
            <el-table-column prop="adv_user_id" label="ADV编号" width="100"> </el-table-column>
            <el-table-column prop="account_name" label="ADV账户名"> </el-table-column>
            <el-table-column prop="agent_name" label="所属代理商"> </el-table-column>
            <el-table-column prop="channel_name" label="渠道销售">
                <template slot-scope="scope">
                    <div>{{ scope.row.channel_name || '--' }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="audit" label="审核状态">
                <template slot-scope="scope">
                    <div v-if="scope.row.audit === '0'" class="audit-btn yellow">待审核</div>
                    <el-tooltip
                        v-else-if="scope.row.audit === '1'"
                        :content="scope.row.audit_reason || ''"
                        placement="top"
                        effect="light"
                    >
                        <div class="audit-btn red">审核驳回</div>
                    </el-tooltip>
                    <div v-if="scope.row.audit === '2'" class="audit-btn green">审核通过</div>
                </template>
            </el-table-column>
            <el-table-column prop="category_name" label="行业"> </el-table-column>
            <el-table-column prop="step_name" label="消费进度"> </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <div v-if="detailType === '2'">
                        <div class="adv-op-btn" @click="handleSimulatedLogin(scope.row)">模拟登陆</div>
                    </div>
                    <div v-else>
                        <div class="adv-op-btn" @click="handleSimulatedLogin(scope.row)">模拟登陆</div>
                        <div v-if="scope.row.audit === '1'" class="adv-op-btn" @click="editAdvertiser(scope.row)">
                            修改
                        </div>
                        <div
                            v-if="showUpdateStepBtn(scope.row)"
                            class="adv-op-btn"
                            @click="handleUpdateStep(scope.row)"
                        >
                            更新进度
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <form-dialog
            :visible.sync="stepForm.display"
            title="更新进度"
            :loading="stepForm.loading"
            @submit="submitStepForm"
            width="500px"
        >
            <el-form :model="stepForm.form" :rules="stepForm.rules" ref="stepForm" label-width="80px">
                <el-form-item label="业务阶段" prop="step_id">
                    <el-radio-group v-model="stepForm.form.step_id">
                        <el-radio v-for="item in stepNextOption" :label="item.id" :key="item.id">{{
                            item.name
                        }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="进度内容" prop="remark">
                    <el-input
                        type="textarea"
                        :rows="4"
                        v-model="stepForm.form.remark"
                        ref="step_form_content"
                    ></el-input>
                </el-form-item>
            </el-form>
        </form-dialog>
    </div>
</template>
<script>
import $util from '@/common/js/util';
import FormDialog from '@/components/FormDialog';
import Request from '@/core/QuRequest';
const req = new Request();

export default {
    name: 'AdvTable',
    components: { FormDialog },
    props: {
        upAdvMessage: {
            type: Boolean,
            default: false
        },
        detailType: {
            type: String,
            required: true,
            default: ''
        },
        productId: {
            type: String,
            default: ''
        },
        owner: {
            type: String,
            default: ''
        },
        customerId: {
            type: String,
            default: ''
        },
        steps: {
            type: Array,
            required: true,
            default: () => []
        }
    },

    watch: {
        upAdvMessage (newMessage, oldMessage) {
            // 只要这个upAdvMessage监听到变化，就重新获取数据
            this._getAdvLists();
        }
    },

    computed: {
        stepNextOption () {
            const stepId = this.currentItem.step_id * 1;
            const steps = [...this.steps];
            const stepActIn = steps.findIndex(step => step.id * 1 === stepId);
            return steps.splice(stepActIn, 2);
        }
    },

    data: () => ({
        advList: [],
        stepForm: {
            form: {
                step_id: '',
                remark: ''
            },
            rules: {
                step_id: [{ required: true, message: '请选择进度', triggle: 'change' }],
                remark: [
                    { required: true, message: '进度内容必填', triggle: 'change' },
                    { min: 15, max: 2014, message: `长度为15-1024`, triggle: 'change' }
                ]
            },
            display: false,
            loading: false
        },
        currentItem: {}
    }),

    methods: {
        showUpdateStepBtn (item) {
            // 是5或者6步骤, 并且审核通过
            if (item.audit === '2' && (item.step_id === '5' || item.step_id === '6')) {
                return true;
            } else {
                return false;
            }
        },
        // 更新进度
        handleUpdateStep (item) {
            this.currentItem = item;
            this.stepForm.display = true;
            this.stepForm.form.remark = '';
            this.stepForm.form.step_id = item.step_id;
            // 自动聚焦内容
            this.$nextTick(() => {
                this.$refs.step_form_content.focus();
            });
        },

        // 提交更新进度
        submitStepForm () {
            this.$refs['stepForm'].validate(valid => {
                if (valid) {
                    this.processSubmit();
                } else {
                    return false;
                }
            });
        },

        // async 提交进度
        async processSubmit () {
            try {
                const params = {
                    ...this.stepForm.form,
                    customer_id: this.currentItem.customer_id,
                    product_id: this.currentItem.product_id,
                    adv_user_id: this.currentItem.adv_user_id
                };
                this.submitLoading = true;
                await req.send(req.Apis.sales.customerStage2.setAccountStatus, params).fin(() => {
                    this.submitLoading = false;
                });
                this.stepForm.display = false;
                this.$message.success('更新成功！');
                // 通知父层更新进度完成
                this.$emit('update-step-succ');
            } catch (err) {
                this.$message({
                    message: `更新进度失败：${err.message || '未知错误'}`,
                    type: 'error',
                    duration: 4000
                });
            }
        },

        // adv维度修改账户
        editAdvertiser (item) {
            let id = this.customerId;
            let owner = this.owner;
            let formType = 'edit'; // 开户的标识
            let advInfo = JSON.stringify(item);
            this.$router.push({
                name: 'AdvertiserManagePrivateInitAder',
                query: { id, owner, formType, advInfo }
            });
        },

        handleSimulatedLogin (item) {
            $util.simulatedLogin(item.adv_user_id, 1);
        },

        async _getAdvLists () {
            try {
                const params = {
                    product_id: this.productId || '',
                    customer_id: this.customerId || ''
                };
                const res = await req.send(req.Apis.sales.customerStage2.productAccount, params);
                if (res.code === 200) {
                    this.advList = [...res.data] || [];
                }
            } catch (err) {
                this.$message.error(`获取产品下的开户信息失败：${err.message || '未知错误'}`);
            }
        }
    },

    created () {
        this._getAdvLists();
    }
};
</script>
<style lang="less" scoped>
.adv-table {
    /deep/ .content-header-row {
        color: #303133;
    }
    /deep/ .content-cell {
        background: #f9fbfe;
    }
    /deep/ .content-header-cell {
        background: #f9fbfe;
    }
    .adv-op-btn {
        display: inline-block;
        vertical-align: middle;
        margin-right: 16px;
        font-size: 14px;
        font-weight: bold;
        color: #2f9eff;
        cursor: pointer;
        &:last-child {
            margin-right: 0;
        }
    }
    .audit-btn {
        width: 68px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        color: #fff;
        border-radius: 4px;
        &.yellow {
            background: #f6b423;
        }
        &.red {
            background: #ff6161;
        }
        &.green {
            background: #4cd34b;
        }
    }
}
</style>
